<ng-container *ngIf="memberCard$ | async as card; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card">
    <!--Details-->
    <div class="upper-barcode-container d-flex flex-row align-items-center justify-content-between">
      <!--Name and ID-->
      <div class="d-flex flex-column gap-1">
        <h4
          class="member-name font-size-16 fw-bold text-uppercase mb-0 text-white"
          *ngIf="memberDetails$ | async as memberDetails"
        >
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h4>
        <div class="d-flex flex-row align-items-center font-size-14 text-white">
          <span>{{ card.ProductCode }}</span>
          <span class="px-1">-</span>
          <span>{{ card.MemberId }}</span>
        </div>
      </div>

      <img class="card-logo" [src]="'logos/logo.svg' | contentAssetImage" alt="" />
    </div>

    <!--Balances-->
    <div class="points-balance-container d-flex flex-row align-items-center">
      <div class="balance d-flex flex-row align-items-center">
        <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>

        <div class="points-container d-flex flex-column justify-content-center">
          <span class="fw-bold text-white font-heading font-size-18">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
          <span class="font-size-12 text-white text-capitalize">{{ 'barcode.your.points' | translate }}</span>
        </div>
      </div>

      <div class="balance d-flex flex-row align-items-center">
        <span class="icons material-symbols-outlined text-white"> money_bag </span>

        <div class="points-container d-flex flex-column justify-content-center">
          <span class="fw-bold text-white font-heading font-size-18">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
          <span class="font-size-12 text-white text-capitalize">{{ 'barcode.credits' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- payments -->
    <fgb-ecash-button [isMemberCard]="false"></fgb-ecash-button>

    <!-- discount -->
    <ng-container *ngIf="card.DiscountLevel && card.DiscountLevel !== '0'">
      <div class="discount-container d-flex w-100 align-items-center justify-content-between">
        <span class="font-size-14 text-white">{{ 'wallet.discount.label' | translate }}</span>
        <span class="font-size-14 text-white fw-bold">{{ card.DiscountLevel }}%</span>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
